/** Width:height for the signature drawing area (matches prior 600×150 export ratio). */
export const SIGNATURE_CANVAS_ASPECT_RATIO = 4;

/** 15rem at 16px root — minimum drawable width on narrow viewports. */
export const MIN_SIGNATURE_CANVAS_WIDTH = 240;

/** 37.5rem at 16px root — upper bound so exported PNGs stay reasonable on wide modals. */
export const MAX_SIGNATURE_CANVAS_WIDTH = 600;

export const DEFAULT_SIGNATURE_CANVAS_LAYOUT_WIDTH = MAX_SIGNATURE_CANVAS_WIDTH;

export interface SignatureCanvasDimensions {
  bitmapHeight: number;
  bitmapWidth: number;
  layoutHeight: number;
  layoutWidth: number;
}

/**
 * Derives layout and bitmap dimensions from the canvas wrapper width.
 * Bitmap matches layout pixels so stroke coordinates stay aligned with
 * `react-signature-canvas` (the library does not scale for devicePixelRatio).
 */
export function computeSignatureCanvasDimensions(containerWidth: number): SignatureCanvasDimensions | null {
  if (!Number.isFinite(containerWidth) || containerWidth <= 0) {
    return null;
  }

  const layoutWidth = Math.round(
    Math.min(Math.max(containerWidth, MIN_SIGNATURE_CANVAS_WIDTH), MAX_SIGNATURE_CANVAS_WIDTH),
  );
  const layoutHeight = Math.round(layoutWidth / SIGNATURE_CANVAS_ASPECT_RATIO);

  return {
    bitmapHeight: layoutHeight,
    bitmapWidth: layoutWidth,
    layoutHeight,
    layoutWidth,
  };
}

export function getDefaultSignatureCanvasDimensions(): SignatureCanvasDimensions {
  return computeSignatureCanvasDimensions(DEFAULT_SIGNATURE_CANVAS_LAYOUT_WIDTH)!;
}
